import { bridge } from '../../../bridge';

/**
 * - 찜 서랍 페이지로 이동
 */
export const moveToLikeFolders = ({ folderSno }: { folderSno: number }) => {
  bridge.openDeeplink(`ably://like/folders/${folderSno}`, {
    webCallback: () => {
      alert('해당 기능은 앱에서 사용가능합니다.');
    },
  });
};
